import { cn } from '@/lib/utils';
import { ChevronDown } from 'lucide-react';
import React from 'react';

export type SortOption = 'relevance' | 'price_low' | 'price_high' | 'newest' | 'oldest';

export interface SortOptionItem {
    value: SortOption;
    label: string;
}

interface BoatResultsHeaderProps {
    resultLabel?: string;
    totalResults: number;
    sortBy: SortOption;
    onSortChange: (sort: SortOption) => void;
    sortOptions?: SortOptionItem[];
    /** H2 opcional acima dos cards. Sem ele, nenhum H2 é renderizado (evita H2 vazio). Nunca exibir contagem de resultados. */
    heading?: string;
}

export const BOAT_SORT_OPTIONS: SortOptionItem[] = [
    { value: 'relevance', label: 'Mais relevantes' },
    { value: 'price_low', label: 'Menor preço' },
    { value: 'price_high', label: 'Maior preço' },
    { value: 'newest', label: 'Mais recente' },
    { value: 'oldest', label: 'Mais antigo' },
];

export const LISTING_SORT_OPTIONS: SortOptionItem[] = [
    { value: 'relevance', label: 'Mais relevantes' },
    { value: 'newest', label: 'Mais recente' },
];

/**
 * Returns the sort if it is one of the allowed options, otherwise falls back to relevance.
 */
export const resolveSortOption = (sort: unknown, options: SortOptionItem[]): SortOption => {
    return options.find((option) => option.value === sort)?.value ?? 'relevance';
};

export const BoatResultsHeader: React.FC<BoatResultsHeaderProps> = ({ sortBy, onSortChange, sortOptions = BOAT_SORT_OPTIONS, heading }) => {
    return (
        <div className={cn('mb-6 flex', heading ? 'flex-col gap-3 sm:flex-row sm:items-center sm:justify-between' : 'items-center justify-end')}>
            {heading && <h2 className="text-lg font-medium text-gray-900">{heading}</h2>}

            {/* Sort Dropdown */}
            <div className="flex items-center gap-2">
                <span className="text-sm text-gray-600">Ordenar por:</span>
                <div className="relative">
                    <select
                        value={sortBy}
                        onChange={(e) => onSortChange(e.target.value as SortOption)}
                        className="cursor-pointer appearance-none rounded-lg border border-gray-300 bg-white py-2 pr-10 pl-3 text-sm text-gray-700 hover:border-gray-400 focus:border-blue-500 focus:ring-2 focus:ring-blue-500 focus:outline-none"
                    >
                        {sortOptions.map((option) => (
                            <option key={option.value} value={option.value}>
                                {option.label}
                            </option>
                        ))}
                    </select>
                    <div className="pointer-events-none absolute inset-y-0 right-0 flex items-center pr-3">
                        <ChevronDown className="h-4 w-4 text-gray-400" />
                    </div>
                </div>
            </div>
        </div>
    );
};
